export function calculateProfilePrice(tokens?: number, price?: number): number | string {
    if (typeof tokens !== 'number' || typeof price !== 'number' || price === 0) {
        return 0;
    }

    const result = tokens / price;

    if (!Number.isInteger(result)) {
        return 'N/A';
    }

    return result;
}

export function hasLeftover(tokens?: number, price?: number): boolean {
    if (typeof tokens === 'number' && typeof price === 'number' && price !== 0) {
        return tokens % price !== 0;
    }
    return false;
}
